import { IconName } from 'components/Icon/icon-names'

type Bank = {
  id: string
  name: string
  icon: IconName
}

export const banks: Bank[] = [
  {
    id: '001',
    name: 'Banco do Brasil',
    icon: 'banco-do-brasil',
  },
  {
    id: '041',
    name: 'Banrisul',
    icon: 'banrisul',
  },
  {
    id: '104',
    name: 'Caixa Econômica Federal',
    icon: 'caixa',
  },
  {
    id: '237',
    name: 'Bradesco',
    icon: 'bradesco',
  },
  {
    id: '341',
    name: 'Itaú',
    icon: 'itau',
  },
  {
    id: '033',
    name: 'Santander',
    icon: 'santander',
  },
]
